import React from 'react'
import { useCoachChat } from './CoachChatContext'
import CandidateInfo from './CandidateInfo'
import CoachTextChatWrap from './CoachTextChatWrap'

/**
 * TextChat component - displays a text-only chat with candidate info
 * @param {Object} props
 * @param {Object} props.candidate - The candidate being chatted with
 * @param {Array} props.messages - Array of chat messages (filtered by chatId/chatSlot)
 * @param {Object} props.selectedCandidate - The selected candidate for this chat slot
 */
const TextChat = ({ candidate, messages, selectedCandidate }) => {
  const { chatManager, connectionState, getDarkModeClasses } = useCoachChat()

  // Get candidate token for CandidateInfo
  // First try to get from candidate object (cached when candidate leaves), then from chat object, then from room API field, then fallback to candidate.username
  // (candidate info is cached using candidate.username as the key)
  const easyrtc = chatManager?.rtcService?.getEasyRTC()

  // Try to get candidateToken from candidate object first (set by getCandidateFromChat)
  const candidateTokenFromCandidate = candidate?.candidateToken

  // Try to get candidateToken from the active chat object (persists when candidate leaves)
  const activeChat = connectionState.activeChats?.find(
    (chat) =>
      chat.candidateEasyrtcid === candidate?.easyrtcid ||
      chat.candidateId === candidate?.easyrtcid,
  )
  const candidateTokenFromChat = activeChat?.candidateToken

  // Fallback to room API field if not in chat object
  const candidateTokenFromRoom =
    easyrtc &&
    candidate?.easyrtcid &&
    easyrtc.getRoomApiField(
      connectionState.chatRoom,
      candidate.easyrtcid,
      'chatToken',
    )

  const candidateToken =
    candidateTokenFromCandidate ||
    candidateTokenFromChat ||
    candidateTokenFromRoom ||
    candidate?.username

  return (
    <div
      className={`flex h-full min-h-0 flex-col overflow-hidden ${getDarkModeClasses(
        'bg-white',
        'bg-gray-800',
      )}`}
    >
      {/* Candidate Info on top */}
      <div
        className={`flex flex-shrink-0 flex-col border-b ${getDarkModeClasses(
          'border-gray-200',
          'border-gray-600',
        )}`}
      >
        {candidateToken ? (
          <CandidateInfo
            chatToken={candidateToken}
            slotCandidateEasyrtcid={candidate?.easyrtcid}
          />
        ) : (
          <div
            className={`flex h-full items-center justify-center text-sm ${getDarkModeClasses(
              'text-gray-500',
              'text-gray-400',
            )}`}
          >
            Candidate Info
            <br />
            <span className="text-xs">(Not available)</span>
          </div>
        )}
      </div>

      {/* Text Chat Wrap below */}
      <div className="min-h-0 flex-1 overflow-hidden">
        <CoachTextChatWrap
          messages={messages}
          candidate={candidate}
          selectedCandidate={selectedCandidate}
        />
      </div>
    </div>
  )
}

export default TextChat
